angular.module('boc')
  .value('setAs', function(obj, prop, val) {
    return function(data) { obj[prop] = val || data }
  })
